import gql from 'graphql-tag';

const SUBMIT_FEEDBACK_OPERATION_NAME = 'SubmitFeedback';

const SUBMIT_FEEDBACK_MUTATION = gql`
    mutation ${SUBMIT_FEEDBACK_OPERATION_NAME}($context: ContextInput!, $feedback: DirectFeedbackValuesInput!, $id: ID!) {
        directFeedbackSubmit(context: $context, id: $id, feedback: $feedback) {
            errors {
                error
            }
        }
    }
`;

export {SUBMIT_FEEDBACK_MUTATION, SUBMIT_FEEDBACK_OPERATION_NAME};
